module.exports = __webpack_public_path__ + "img/icon3.becb060e.png";